"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeProvider = exports.ThemeContext = exports.THEME_LIGHT = exports.THEME_DARK = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const THEME_LIGHT = "light";
exports.THEME_LIGHT = THEME_LIGHT;
const THEME_DARK = "dark";
exports.THEME_DARK = THEME_DARK;
const THEMES = {
  [THEME_LIGHT]: true,
  [THEME_DARK]: true
};

const ThemeProvider = _ref => {
  let {
    initialTheme,
    ...props
  } = _ref;
  const [theme, setTheme] = (0, _react.useState)(initialTheme);
  const value = (0, _react.useMemo)(() => ({
    theme,
    setTheme
  }), [theme]);
  return /*#__PURE__*/_react.default.createElement(ThemeContext.Provider, _extends({
    value: value
  }, props));
};

exports.ThemeProvider = ThemeProvider;
ThemeProvider.defaultProps = {
  initialTheme: THEME_LIGHT
};
ThemeProvider.propTypes = {
  initialTheme: _propTypes.default.oneOf(Object.keys(THEMES)).isRequired
};
const ThemeContext = /*#__PURE__*/(0, _react.createContext)();
exports.ThemeContext = ThemeContext;